import React, { useEffect, useState } from "react";
import { authFetch, apiUrl } from "../../utils/api";

/**
 * SlashSkillMenu — type "/" at the start of the composer and pick a skill to
 * run this turn ("/weekly-client-recap for Dottie"). Pure UI: the server
 * resolves the slug (custom shadows built-in; reserved bot commands ignored).
 */
let cache = { at: 0, list: [] };
export async function loadSkillMenu() {
  if (Date.now() - cache.at < 5 * 60 * 1000 && cache.list.length) return cache.list;
  try {
    const r = await authFetch(apiUrl("/api/skills"));
    if (!r.ok) return cache.list;
    const d = await r.json();
    const list = (d.skills || d || []).map((s) => ({ slug: s.slug, name: s.name, description: s.description || "", custom: !!s.is_custom }));
    cache = { at: Date.now(), list };
  } catch (_) { /* keep stale */ }
  return cache.list;
}

export function slashQuery(input) {
  const m = String(input || "").match(/^\/([a-z0-9-]*)$/i);
  return m ? m[1].toLowerCase() : null;
}

const SlashSkillMenu = ({ query, activeIndex, onPick, onMatches }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { loadSkillMenu().then((list) => { const q = query || ""; const m = list.filter((s) => s.slug.includes(q) || s.name.toLowerCase().includes(q)).sort((a, b) => (b.custom - a.custom) || a.slug.localeCompare(b.slug)).slice(0, 8); setItems(m); onMatches && onMatches(m); }); }, [query]);
  if (!items.length) return null;
  return (
    <div className="slash-skill-menu" role="listbox" data-testid="slash-skill-menu">
      {items.map((s, i) => (
        <button key={s.slug} type="button" role="option" aria-selected={i === activeIndex} className={`slash-skill-item ${i === activeIndex ? "active" : ""}`} onMouseDown={(e) => { e.preventDefault(); onPick(s); }}>
          <span className="slash-skill-slug">/{s.slug}</span>
          <span className="slash-skill-desc">{s.custom ? "★ " : ""}{s.description.split(/[.!?]/)[0].slice(0, 80)}</span>
        </button>
      ))}
    </div>
  );
};

export default SlashSkillMenu;
